document.addEventListener('DOMContentLoaded', () => {
  const swiperLogo = setSwiperLogo();
  
  const iconLottie = new UWL('.lottie', {
    run: 'uwl-run',
    pause: 'uwl-pause',
    reverse: 'uwl-reverse',
  });

  UWX.ScrollActionSelfElement('.lottie ', {
    rootMargin: '10px 20px',
    activeClass: 'uwl-run',
    timing: .5,
    once: true,
    direction: 'both',
  });

  const uwb = new UWB({
    uaTabletViewport: {
      init: true,
      width: 1140,
    },
    toolSmoothScroll: {
      offsetSelector: ['slideout'],
    },
  });
  
  if (window.matchMedia("(max-width: 768px)").matches) {
    UWX.ElementReplace('.cover-caution', '.cover-image_wrap', 'afterend');
  }

  const startFire = document.documentElement.clientHeight / 2;
  UWX.ScrollActionReferPosition('.page_header', startFire, { activeClass: 'fixed' });
  UWX.ScrollActionReferPosition('.page-top', startFire);

  UWX.MenuNext('.faq-list dt');
  UWX.MenuNth('.service-point_nav li', '.service-point_list li.point_item');

  UWX.Waiting('.point01', { delayMSec: 300, activateClass: 'action', });
  UWX.Waiting('.point02', { delayMSec: 600, activateClass: 'action', });
  UWX.Waiting('.cover-title', { delayMSec: 900, activateClass: 'action', });
  UWX.Waiting('.cover-logo', { delayMSec: 900, activateClass: 'action', });
  UWX.Waiting('.cover-caution', { delayMSec: 900, activateClass: 'action', });
  UWX.Waiting('.cover-image .image', { delayMSec: 600, activateClass: 'action', });
  UWX.Waiting('.cover-image .ico-price', { delayMSec: 900, activateClass: 'action', });
  UWX.Waiting('.download_image', { delayMSec: 900, activateClass: 'action', });

  UWX.ScrollActionSelfElement('.reveal, .fadeIn, .arrow, .bf, .af ', {
    rootMargin: '10px 20px',
    activeClass: 'action',
    timing: .5,
    once: true,
    direction: 'both',
  });

  UWX.ScrollActionSelfElement('.problem01', {
    rootMargin: '10px 20px',
    activeClass: 'wait',
    timing: .5,
    once: true,
    direction: 'both',
  });
  UWX.ScrollActionSelfElement('.problem02', {
    rootMargin: '10px 20px',
    activeClass: 'wait',
    timing: .5,
    once: true,
    direction: 'both',
  });
  UWX.ScrollActionSelfElement('.problem03', {
    rootMargin: '10px 20px',
    activeClass: 'wait',
    timing: .5,
    once: true,
    direction: 'both',
  });
  
  UWX.ScrollActionReferPosition('.page_header', 200, {
    activeClass: 'slideout',
    sedationLine: -100,
    direction: 'down'
  });
  UWX.ScrollActionReferPosition('.page_header', 400, {
    activeClass: 'actived',
    sedationLine: 0,
    once: false,
    direction: 'both'
  });

  UWX.Waiting('.problem01.wait', {
    delayMSec: 500,
    activateClass: 'action',
  })
  UWX.Waiting('.problem02.wait', {
    delayMSec: 1000,
    activateClass: 'action',
  })
  UWX.Waiting('.problem03.wait', {
    delayMSec: 1500,
    activateClass: 'action',
  })

  setListContorol()
});

const setListContorol = () => {
  const navs = document.querySelectorAll('.service-point_nav ul li')
  const items = document.querySelectorAll('.point_item')

  document.querySelector('.prev_list').addEventListener('click', () => {
    const navTarget = document.querySelector('.service-point_nav ul li.actived')
    const itemTarget = document.querySelector('.point_item.actived')
    navTarget.classList.remove('actived')
    itemTarget.classList.remove('actived')
    if(itemTarget.previousElementSibling.classList.contains('point_item')){
      navTarget.previousElementSibling.classList.add('actived')
      itemTarget.previousElementSibling.classList.add('actived')
    }else{
      navs[navs.length - 1].classList.add('actived')
      items[items.length - 1].classList.add('actived')
    }
  })
  document.querySelector('.next_list').addEventListener('click', () => {
    const navTarget = document.querySelector('.service-point_nav ul li.actived')
    const itemTarget = document.querySelector('.point_item.actived')
    navTarget.classList.remove('actived')
    itemTarget.classList.remove('actived')
    if(itemTarget.nextElementSibling.classList.contains('point_item')){
      navTarget.nextElementSibling.classList.add('actived')
      itemTarget.nextElementSibling.classList.add('actived')
    }else{
      navs[0].classList.add('actived')
      items[0].classList.add('actived')
    }
  })
}

const setSwiperLogo = () => {
  return new Swiper('.sliderLogo', {
    loop: true,
    speed: 5000,
    slidesPerView: 'auto',
    spaceBetween: 0,
    direction: 'horizontal',
    freeMode: true,
    autoplay: {
      delay: 0,
      stopOnLast: false,
      disableOnInteraction: false
    },
  });
}
